import { Form, Validators, field } from "fw-model";

const { required, isEmail } = Validators;

export class ForgotPasswordForm extends Form {
    @field("Email Address", required, isEmail)
    public EmailAddress: string = null;
}
